module.exports = __webpack_public_path__ + "images/mobile/gift-7a4a3c663cd0baf301e498685cb19952.svg";